import { render, staticRenderFns } from "./AddressesTab.vue?vue&type=template&id=95c6857c"
import script from "./AddressesTab.vue?vue&type=script&lang=js"
export * from "./AddressesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports